/* tslint:disable:ordered-imports */
import "core-js";
import "zone.js/dist/zone";
/* tslint:enable:ordered-imports */

import { enableProdMode } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";
import { AppModule } from "../app/app.module";

declare const WEBPACK_ENV: string;

if (typeof WEBPACK_ENV !== "undefined" && WEBPACK_ENV && WEBPACK_ENV !== "development") {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule);



// WEBPACK FOOTER //
// ./src/client/main.ts